import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    getVouchersRes: null,
    createVoucherRes: null,
    updateVoucherRes: null,
    deleteVoucherRes: null,
};

const slice = createSlice({
    name: 'voucher',
    initialState,
    reducers: {
        getVouchersRequest: (state) => {
            state.loading = true;
        },
        getVouchersSuccess: (state, action) => {
            state.loading = false;
            state.getVouchersRes = action.payload;
        },
        getVouchersFailure: (state, action) => {
            state.loading = false;
            state.getVouchersRes = action.payload;
        },
        resetGetVouchers: (state) => {
            state.getVouchersRes = null;
        },

        createVoucherRequest: (state) => {
            state.loading = true;
        },
        createVoucherSuccess: (state, action) => {
            state.loading = false;
            state.createVoucherRes = action.payload;
        },
        createVoucherFailure: (state, action) => {
            state.loading = false;
            state.createVoucherRes = action.payload;
        },
        resetCreateVoucher: (state) => {
            state.createVoucherRes = null;
        },

        updateVoucherRequest: (state) => {
            state.loading = true;
        },
        updateVoucherSuccess: (state, action) => {
            state.loading = false;
            state.updateVoucherRes = action.payload;
        },
        updateVoucherFailure: (state, action) => {
            state.loading = false;
            state.updateVoucherRes = action.payload;
        },
        resetUpdateVoucher: (state) => {
            state.updateVoucherRes = null;
        },

        deleteVoucherRequest: (state) => {
            state.loading = true;
        },
        deleteVoucherSuccess: (state, action) => {
            state.loading = false;
            state.deleteVoucherRes = action.payload;
        },
        deleteVoucherFailure: (state, action) => {
            state.loading = false;
            state.deleteVoucherRes = action.payload;
        },
        resetDeleteVoucher: (state) => {
            state.deleteVoucherRes = null;
        },
    },
});

export const {
    getVouchersRequest, getVouchersSuccess, getVouchersFailure, resetGetVouchers,
    createVoucherRequest, createVoucherSuccess, createVoucherFailure, resetCreateVoucher,
    updateVoucherRequest, updateVoucherSuccess, updateVoucherFailure, resetUpdateVoucher,
    deleteVoucherRequest, deleteVoucherSuccess, deleteVoucherFailure, resetDeleteVoucher,
} = slice.actions;

export default slice.reducer;
